/* eslint-disable */

<template>
  <div class="main-border rounded-lg">
    <div>
      <h4 class="p-4">{{ activeCourseInfo.name }} Progress</h4>

      <div class="flex justify-between items-center main-top-border p-4" v-if="courseInfoFetched && progressData.simulations.enabled">
        <vs-tooltip position="left" :text="progressData.simulations.incomplete.map(({ name }) => name).join(', ')">
          <h4 class="mb-1">Simulations</h4>
          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-check" class="h-5 w-5 text-success" />
            Completed Sims: {{ courseInfoFetched ? progressData?.simulations?.completedCount : 0 }}
          </span>

          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-x" class="h-5 w-5 text-danger" />
            Incomplete Sims {{ courseInfoFetched ? progressData?.simulations?.incompleteCount : 0 }}
          </span>

          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-exclamation" class="h-5 w-5 text-warning" />
            Current Grade: {{ courseInfoFetched ? progressData?.simulations?.totalGrade : 0 }}
          </span>
        </vs-tooltip>
        <div>
          <radial-progress-bar
            :diameter="95"
            :completed-steps="progressData?.simulations?.completedCount"
            :total-steps="progressData?.simulations?.total"
            :animateSpeed="1000"
            timingFunc="ease"
            innerStrokeColor="#181d2a"
            startColor="#31B952"
            stopColor="#0cdc62"
            :strokeWidth="6"
            :innerStrokeWidth="6"
          >
            <h2 v-if="courseInfoFetched" class="font-light">{{ Math.round(progressData?.simulations?.totalGradePercent) }}%</h2>
            <h2 v-else class="font-light">0%</h2>
          </radial-progress-bar>
        </div>
      </div>

      <div class="flex justify-between items-center main-top-border p-4" v-if="courseInfoFetched && progressData.flashcards.enabled">
        <vs-tooltip position="left" :text="progressData.flashcards.incomplete.map(({ name }) => name).join(', ')">
          <h4 class="mb-1">FlashCards</h4>
          <p class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-check" class="h-5 w-5 text-success" />
            Completed Sets: {{ courseInfoFetched ? progressData?.flashcards?.completedCount : 0 }}
          </p>

          <p class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-x" class="h-5 w-5 text-danger" />
            Incomplete Sets {{ courseInfoFetched ? progressData?.flashcards?.incompleteCount : 0 }}
          </p>

          <p class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-exclamation" class="h-5 w-5 text-warning" />
            Your Grade: {{ courseInfoFetched ? progressData?.flashcards?.totalGrade : 0 }}
          </p>
        </vs-tooltip>
        <div>
          <radial-progress-bar
            :diameter="95"
            :completed-steps="progressData?.flashcards?.completedCount"
            :total-steps="progressData?.flashcards?.total"
            :animateSpeed="1000"
            timingFunc="ease"
            innerStrokeColor="#181d2a"
            startColor="#31B952"
            stopColor="#0cdc62"
            :strokeWidth="6"
            :innerStrokeWidth="6"
          >
            <h2 v-if="courseInfoFetched" class="font-light">{{ Math.round(progressData?.flashcards?.totalGradePercent) }}%</h2>
            <h2 v-else class="font-light">0%</h2>
          </radial-progress-bar>
        </div>
      </div>

      <div class="flex justify-between items-center main-top-border p-4" v-if="courseInfoFetched && progressData.examedge.enabled">
        <div>
          <h4 class="mb-1">ExamEdge</h4>
          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-check" class="h-5 w-5 text-success" />
            Passed Asgmts:
            <p v-if="courseInfoFetched">{{ progressData?.examedge?.passedCount }}</p>
            <p v-else>0</p>
          </span>

          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-x" class="h-5 w-5 text-danger" />
            Incomplete Asgmts:
            <p v-if="courseInfoFetched">{{ progressData?.examedge?.incompleteCount - progressData?.examedge?.incompleteCount }}</p>
            <p v-else>0</p>
          </span>

          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-exclamation" class="h-5 w-5 text-warning" />
            Your Grade:
            <p v-if="courseInfoFetched">{{ progressData?.examedge?.totalGrade }}</p>
            <p v-else>0</p>
          </span>
        </div>
        <div>
          <radial-progress-bar
            :diameter="95"
            :completed-steps="progressData?.examedge?.passedCount"
            :total-steps="progressData?.examedge?.total"
            :animateSpeed="1000"
            timingFunc="ease"
            innerStrokeColor="#181d2a"
            startColor="#31B952"
            stopColor="#0cdc62"
            :strokeWidth="6"
            :innerStrokeWidth="6"
          >
            <h2 v-if="courseInfoFetched" class="font-light">{{ Math.round(progressData?.examedge?.totalGradePercent) }}%</h2>
            <h2 v-else class="font-light">0%</h2>
          </radial-progress-bar>
        </div>
      </div>

      <div class="flex justify-between items-center main-top-border p-4" v-if="courseInfoFetched && progressData.labs.enabled">
        <div>
          <h4 class="mb-1">Labs</h4>
          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-check" class="h-5 w-5 text-success" />
            Passed Asgmts:
            <p v-if="courseInfoFetched">{{ progressData?.labs?.passedCount }}</p>
            <p v-else>0</p>
          </span>

          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-x" class="h-5 w-5 text-danger" />
            Incomplete Asgmts:
            <p v-if="courseInfoFetched">{{ progressData?.labs?.incompleteCount - progressData?.labs?.incompleteCount }}</p>
            <p v-else>0</p>
          </span>

          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-exclamation" class="h-5 w-5 text-warning" />
            Your Grade:
            <p v-if="courseInfoFetched">{{ progressData?.labs?.totalGrade }}</p>
            <p v-else>0</p>
          </span>
        </div>
        <div>
          <radial-progress-bar
            :diameter="95"
            :completed-steps="progressData?.labs?.passedCount"
            :total-steps="progressData?.labs?.total"
            :animateSpeed="1000"
            timingFunc="ease"
            innerStrokeColor="#181d2a"
            startColor="#31B952"
            stopColor="#0cdc62"
            :strokeWidth="6"
            :innerStrokeWidth="6"
          >
            <h2 v-if="courseInfoFetched" class="font-light">{{ Math.round(progressData?.labs?.totalGradePercent) }}%</h2>
            <h2 v-else class="font-light">0%</h2>
          </radial-progress-bar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import RadialProgressBar from 'vue-radial-progress';

export default {
  data() {
    return {
      courseInfoFetched: false,
      examEdgePercentFormatted: 0,
      progressData: {},
    };
  },
  methods: {
    fetchCourseProgressData() {
      if (this.activeCourseSubscription) {
        this.$http
          .post('user/@me/compliance-by-subscription', { subscriptionId: this.activeCourseSubscription })
          .then((response) => {
            this.progressData = response.data.insights;
            this.courseInfoFetched = true;
          })
          .catch((error) => {
            console.error('Error fetching progress data:', error);
          });
      } else if (this.activeCourseInfo.id !== '') {
        this.$http
          .post('user/@me/compliance', { courseId: this.activeCourseInfo.id })
          .then((response) => {
            this.progressData = response.data.insights;
            this.courseInfoFetched = true;
          })
          .catch((error) => {
            console.error('Error fetching progress data:', error);
          });
      }
    },
  },
  components: {
    Prism,
    RadialProgressBar,
  },
  computed: {
    activeCourseInfo() {
      return this.$store.state.AppActiveCourse;
    },
    activeCourseSubscription() {
      return this.$store.state.AppActiveCourse.subscription.id || null;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  mounted() {
    this.fetchCourseProgressData();
  },
};
</script>
